import { render, staticRenderFns } from "./ResponsibleInformation.vue?vue&type=template&id=6f85d11c"
import script from "./ResponsibleInformation.vue?vue&type=script&lang=js"
export * from "./ResponsibleInformation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports